/**
 * アイコン掲載順
 *
 * @export IconPublishOrder
 * @class IconPublishOrder
 */
export class IconPublishOrder {
    constructor(
        public groupCode: string,
        public iconCode: string,
        public iconName: string,
        public publishOrder: string,
        public iconFileUrl: string,
    ) {}
}
